function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSearch = function SvgSearch(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props),
    /*#__PURE__*/
    React.createElement("circle", {
      cx: 8.0503,
      cy: 8.0503,
      r: 6,
      transform: "translate(-3.3345 8.0503) rotate(-45)",
      style: {
        fill: "none",
        stroke: "currentColor",
        strokeMiterlimit: 10,
        strokeWidth: 2
      }
    }),
    /*#__PURE__*/
    React.createElement("line", {
      x1: 12.2929,
      y1: 12.2929,
      x2: 17.9497,
      y2: 17.9497,
      style: {
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 2
      }
    }))
  );
};

export default SvgSearch;